import { useEffect, useState } from "react";

function updateCorrelator() {
    window.Sparkle.cmd.push(() => {
        window.Sparkle.updateCorrelator();
    });
}

const useUpdateCorrelator = (
    isInViewport: boolean,
    onUpdate = updateCorrelator
) => {
    const [prevIsInViewport, setPrevIsInViewport] = useState(isInViewport);

    useEffect(() => {
        if (isInViewport && !prevIsInViewport) {
            onUpdate();
        }

        if (isInViewport !== prevIsInViewport) {
            setPrevIsInViewport(isInViewport);
        }
    }, [isInViewport, prevIsInViewport, setPrevIsInViewport, onUpdate]);
};

export default useUpdateCorrelator;
